import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useTransfersContext} from "../TransfersContext";
import styles from './TransfersStatsPanel.module.scss';

const TransfersStatsPanel = () => {
  const {totalCountTransfers} = useTransfersContext();

  return (
    <div className={styles.statsContainer}>
      <span className={styles.statsItem}>
        <FormattedMessage
          id={'transfers-stats-agent-totalCount'}
          defaultMessage={'Transfers for agent {count}'}
          values={{count: totalCountTransfers}}
        />
      </span>
    </div>
  );
};

export default TransfersStatsPanel;
